import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StatutProfessionnel } from 'src/app/shared/models/statutProfessionnel';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StatutProfessionnelModalAjoutComponent } from '../modal/statutProfessionnel-modal-ajout/statutProfessionnel-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { StatutProfessionnelModalDetailComponent } from '../modal/statutProfessionnel-modal-detail/statutProfessionnel-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-statutProfessionnel',
	templateUrl: './list-statutProfessionnel.component.html',
	styleUrls: ['./list-statutProfessionnel.component.scss']
})
export class ListStatutProfessionnelComponent implements OnInit {
	statutProfessionnel: StatutProfessionnel[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	statutProfessionnelCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editStatutProfessionnelModalRef: BsModalRef;
	addStatutProfessionnelModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getStatutProfessionnel();
		this.isAddable = true;
	}

	getStatutProfessionnel(): void {
		this.isListingLoading = true;
		this.facade.statutProfessionnelService.getAllStatutProfessionnel().subscribe({
			next: (val) => {
				this.statutProfessionnel = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.statutProfessionnel.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.statutProfessionnel = [];
			}
		});
	}

	selectStatutProfessionnel(statutProfessionnel: StatutProfessionnel): void {
		const link = ['/statutProfessionnel', statutProfessionnel.id];
		this.router.navigate(link);
	}

	importStatutProfessionnel(event: any): void {
		this.statutProfessionnelCsvFile = event.target.files[0];

		this.facade.statutProfessionnelService
			.importStatutProfessionnel(this.statutProfessionnelCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} statutProfessionnel ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getStatutProfessionnel();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addStatutProfessionnelModalRef = this.modalService.show(
			StatutProfessionnelModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addStatutProfessionnelModalRef.onHide.subscribe((reason: string | any) => {
			this.getStatutProfessionnel();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(statutProfessionnel: StatutProfessionnel) {
		const initialState = {
			statutProfessionnel: statutProfessionnel
		};
		this.editStatutProfessionnelModalRef = this.modalService.show(
			StatutProfessionnelModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editStatutProfessionnelModalRef.onHide.subscribe((reason: string | any) => {
			this.getStatutProfessionnel();
		});
	}
}
